import { render, staticRenderFns } from "./numcard.vue?vue&type=template&id=2aaeee2e&scoped=true&"
import script from "./numcard.vue?vue&type=script&lang=js&"
export * from "./numcard.vue?vue&type=script&lang=js&"
import style0 from "./numcard.vue?vue&type=style&index=0&id=2aaeee2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaeee2e",
  null
  
)

export default component.exports